<div class="bookmark-container">
  <span class="material-icons bookmark-span" [class.bookmark-red]="_isBookmarked" (click)="toggleBookmark()">
    {{ _isBookmarked ? 'bookmark' : 'bookmark_border' }}
  </span>
  @if (_showCount) {
    <!-- <div class="bookmark-count">{{ _count }}</div> -->
  }
</div>
